import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Token from './pages/Token';
import Navbar from './components/Navbar';
import { CssBaseline, Box } from '@mui/material';
import Reporting from './pages/Reporting';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import './themes.css';
import theme from './theme';

const App = () => {

  return (
    <Router>
      <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box display="flex" height="100vh">
        <Box component="main" sx={{ flexGrow: 1, overflow: 'auto', backgroundColor: 'var(--background-color)', }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/reporting" element={<Reporting />} />
            <Route path="/token/:symbol" element={<Token />} />
          </Routes>
        </Box>
      </Box>
      </ThemeProvider>
    </Router>
  );
};

export default App;
